export default  {"src":"/_next/static/image/public/assets/nevo-boi/logo-small.33532d0fad898578ff87b5ffe5bf1fca.svg","height":79,"width":300};